import React from 'react';
import { XIcon } from 'lucide-react';
export function NotForWhomSection() {
  const items = ['Quem procura uma dieta radical', 'Quem quer um milagre sem mudar nada', 'Quem não quer seguir um passo a passo simples', 'Quem busca tratamento médico para uma condição específica', 'Quem espera resultados extremos ou irreais'];
  return <section className="py-12 bg-white" data-id="element-182">
      <div className="max-w-3xl mx-auto px-5 md:px-8" data-id="element-183">
        <div className="bg-brand-pink/20 rounded-3xl p-8 md:p-12 border border-brand-pink/50 shadow-sm" data-id="element-184">
          <h2 className="text-3xl font-serif font-bold text-brand-dark mb-8 text-center" data-id="element-185">
            Para Quem Não É
          </h2>
          <ul className="space-y-4" data-id="element-186">
            {items.map((item, index) => <li key={index} className="flex items-start opacity-80" data-id="element-187">
                <div className="bg-brand-pink/50 p-1 rounded-full mr-4 flex-shrink-0 mt-0.5" data-id="element-188">
                  <XIcon className="w-5 h-5 text-brand-dark" data-id="element-189" />
                </div>
                <span className="text-brand-text text-lg" data-id="element-190">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}